import React from 'react';
export function HeaderLogo() {
  return <a href="/" className="flex items-center" data-id="element-2713">
      <img src="https://cdn.magicpatterns.com/uploads/5H82rnwCrH9dHxQ46pA82h/Peak_Machine_Sales_Home.png" alt="Peak Machine Sales Logo" className="block h-16 w-auto" data-id="element-2714" />
    </a>;
}